module.exports = __webpack_public_path__ + "img/map_2.382f7e86.png";